import { render, staticRenderFns } from "./VideoShow.vue?vue&type=template&id=fbc81460&"
import script from "./VideoShow.vue?vue&type=script&lang=js&"
export * from "./VideoShow.vue?vue&type=script&lang=js&"
import style0 from "./VideoShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports